import { Badge } from "@chakra-ui/react";

const BadgeQueueNotifyStatus = ({ value }) => {
    let color = "gray"
    let text = ""

    if (value) {
        color = "green"
        text = "แจ้งนัดแล้ว"
    } 

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeQueueNotifyStatus